'use strict';

module.exports = require('ck-core/source/functions/makeLang')({
	TITLE: 'Login',
	HEADER: 'Login',
	FORM: {
		username: 'Username or Email',
		password: 'Password'
	},
	LOGIN_BUTTON: 'Login',
	STAFF_LOGIN_BUTTON: 'Staff Login',
	SEND_EMAIL_LOGIN_LINK: 'Email Login Link',
	FORGOT_PASSWORD: 'Forgot your password?',
	WARNING: {
		SEQUENCER: 'You must be logged in to access the Code Editor!',
		CHECKOUT: 'You must be signed in to use the checkout!',
		DISCOUNT: 'Please login in order to apply your discount'
	},
	NOT_REGISTERED: "Don't have an account?",
	START_HERE: 'Get started here'
});
